import { PlanType } from '@/common/permission'
import { t } from '@/lang'
import { MessageBox } from 'element-ui'
export const playable = [
  {
    key: 'downloads_and_push',
    extraKey: 'extra_downloads_and_push',
    unit: t('playTurbo.account.unit.item'),
    title: t('playTurbo.account.playable.download'),
    notes: t('playTurbo.account.playable.notes'),
    notesTip: t('playTurbo.account.playable.notesTip'),
  },
]

export const video = [
  {
    key: 'video_credits',
    extraKey: 'extra_video_credits',
    unit: t('playTurbo.account.unit.coin'),
    title: t('playTurbo.account.unit.coin'),
  },
]

export const packageDict = {
  1: playable,
  2: video,
  3: playable.concat(video),
}

export function getPlansTitle(scope: number, planType?: PlanType) {
  let title

  if (planType === PlanType.Recharge) {
    return t('playTurbo.account.subscribe.accountBalance')
  }

  switch (scope) {
    case 1:
      title = t('playTurbo.account.playable.title')
      break
    case 2:
      title = t('playTurbo.account.video.title')
      break
    case 3:
      title = `${t('playTurbo.account.playable.title')}&${t(
        'playTurbo.account.video.title',
      )}`
      break
    default:
      title = '-'
  }
  return title
}

export function registerAlert(otherTitle?: string, otherDesc?: string): void {
  MessageBox.alert(
    String(otherDesc || t('playTurbo.account.subscribe.desc')),
    String(otherTitle || t('playTurbo.account.subscribe.title')),
    {
      confirmButtonText: String(t('playTurbo.account.subscribe.ok')),
      callback: (action) => {
        console.log(action)
      },
      customClass: 'pt-custom-alert-message',
      dangerouslyUseHTMLString: true,
    },
  )
}

export function getStorageTime(userPlans: any, key: string): string {
  // 正式
  const mainStorage = userPlans.filter((item: any) => {
    return item.type === 1
  })
  // 试用
  const trialStorage = userPlans.filter((item: any) => {
    return item.type === 2
  })
  if (mainStorage.length) {
    return mainStorage[0][key]
  } else if (trialStorage.length) {
    return trialStorage[0][key]
  }
  return '-'
}

export function getCount(num: number, compute: boolean): number | string {
  if (num === -1) {
    return String(t('playTurbo.account.unlimited'))
  }
  return compute ? (num / 60 / 60).toFixed(2) : num
}

export function hasNuit(num: number): boolean {
  return num !== -1
}

// 套餐可用余额不足
export function checkPlanBalanceEnable(userList: any[]): boolean {
  const planBalance: boolean[] = []

  if (userList.length) {
    userList.forEach((item) => {
      // @ts-ignore
      const contentPackage = packageDict[item.scope]

      contentPackage.forEach((s: any) => {
        if (
          hasNuit(item[s.key][0] + item[s.extraKey][0]) &&
          hasNuit(item[s.key][1] + item[s.extraKey][1])
        ) {
          if (
            item[s.key][1] + item[s.extraKey][1] > 0 &&
            item[s.key][0] + item[s.extraKey][0] === 0
          ) {
            planBalance.push(true)
          } else {
            planBalance.push(false)
          }
        } else {
          planBalance.push(false)
        }
      })
    })

    return planBalance.every((t) => t === true)
  }
  return false
}
